import React from 'react';

import { ClauseText } from './Components/ContractText';

interface Props {
  zoning: string;
}

const Zoning = ({ zoning }: Props) => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        ZONING
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside text-bold">
        <li>
          Failure of this Agreement to contain the zoning classification (except
          in cases where the property and each parcel thereof, if subdividable,
          is zoned solely or primarily to permit single-family dwellings) will
          render this Agreement voidable at Buyer’s option, and, if voided, any
          deposits tendered by the Buyer will be returned to the Buyer without
          any requirement for court action.
        </li>
        <li>
          Zoning Classification, as set forth in the local zoning ordinance:{' '}
          <ClauseText>{zoning || ''}</ClauseText>
        </li>
      </ol>
    </div>
  );
};

export default Zoning;
